<template>
  <div class="p-4">
    <button
      @click="$router.back()"
      class="mb-4 bg-gray-300 hover:bg-gray-400 text-gray-800 px-4 py-2 rounded shadow"
    >
      ⬅️ ย้อนกลับ
    </button>

    <!-- Grid 2 ฝั่ง -->
    <div class="grid grid-cols-1 md:grid-cols-3 gap-4">
      <!-- แชทด้านซ้าย (2 ส่วนจาก 3) -->
      <div class="md:col-span-2">
        <ChatPanel v-if="user" :user="user" />
      </div>

      <!-- ตะกร้าด้านขวา (1 ส่วนจาก 3) -->
      <div class="md:col-span-1">
        <CartPanel v-if="user" :user="user" />
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import ChatPanel from "@/components/ChatPanel.vue";
import CartPanel from "@/components/CartPanel.vue";

export default {
  name: "ChatPage",
  components: { ChatPanel, CartPanel },
  data() {
    return {
      user: null,
    };
  },
  async mounted() {
  const userId = this.$route.params.user_id; // เป็นเลข เช่น 32

  try {
    const res = await axios.get(`/api/lineuser/${userId}`);
    const { user_id, name } = res.data;

    this.user = {
      user_id, // ✅ ส่ง user_id แบบเลขเข้า ChatPanel และ CartPanel
      name: name || `User ${user_id}`
    };
  } catch (err) {
    console.error("❌ โหลด user ล้มเหลว:", err);
  }
}

};
</script>
